import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

enum MessageType {
 ERROR = 'error',
 SUCCESS = 'success',
 WARNING = 'warning',
 INFORMATION = 'info',
}

const initialState: any = MessageType;

export const snackBarMessageTypeSlice = createSlice({
 name: 'snackBarMessageType',
 initialState: initialState,
 reducers: {
  setSnackBarMessageType: (state, action: PayloadAction<MessageType>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { setSnackBarMessageType } = snackBarMessageTypeSlice.actions;

export default snackBarMessageTypeSlice.reducer;
